<template>
    <div>
        <ErrorIndicator v-if="!loading && error" />
        <LoadingIndicator v-if="loading" />
        <div v-if="!loading && !error">
            <div class="news-block__cards">
                <div class="news-block__cards-header">
                    <h2 class="insights__section-title news-block__title--blue">{{ title }}</h2>
                    <div class="news-block__cards-filters"
                        v-if="showRelatedContentFilters && services && services.length > 0">
                        <DropdownFilter v-for="(category, index) in services" :key="`${index}-${category.id}`"
                            :category="category" :selectedValue="filters[index]"
                            @update="filters[index] = $event; filterContent()"></DropdownFilter>
                    </div>
                </div>
                <div class="news-block__container">
                    <div class="news-block__section news-block__section--left">
                        <template v-for="(insight, index) in featuredLeft" :key="index + '-left'">
                            <InsightsBlock :disableNavigationOnClick="insight.disableNavigationOnClick"
                                :disableGradientOverlay="insight.disableGradientOverlay" :category="insight.category"
                                :url="insight.url" :featuredImageUrl="insight.featuredImageUrl" :title="insight.title"
                                :type="insight.type" :published="insight.published"
                                :podcast-embed-url="insight.podcastEmbedUrl" :video-embed-url="insight.videoEmbedUrl" />
                        </template>
                    </div>
                    <div class="news-block__section news-block__section--right">
                        <template v-for="(insight, index) in featuredRight" :key="index + '-right'">
                            <InsightsBlock :disableNavigationOnClick="insight.disableNavigationOnClick"
                                :disableGradientOverlay="insight.disableGradientOverlay" :category="insight.category"
                                :url="insight.url" :featuredImageUrl="insight.featuredImageUrl" :title="insight.title"
                                :type="insight.type" :published="insight.published"
                                :podcast-embed-url="insight.podcastEmbedUrl" :video-embed-url="insight.videoEmbedUrl" />
                        </template>
                    </div>
                </div>
            </div>
            <div class="news-block__grid">
                <div class="news-block__grid-wrapper">
                    <a v-for="(article, index) in regular" :key="index + '-regular'" :href="article.url"
                        class="news-block__grid-item">
                        <div class="news-block__grid-meta"><span>{{ article.type }}</span><span>{{ article.published
                        }}</span>
                        </div>
                        <h3 class="news-block__grid-title">{{ article.title }}</h3>
                    </a>
                </div>
            </div>
            <div v-if="(!loading && !content) || (!loading && content.length === 0)" class="news-block__no-results">
                <h4>No results found matching your filters.</h4>
            </div>
            <div class="news-block__button" v-show="!loadMoreDisabled">
                <button @click="loadMore" class="button" :disabled="loadMoreDisabled">{{ loading ? 'Loading...' : 'Load More'}}</button>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios';
import InsightsBlock from "./InsightsBlock.vue"
import DropdownFilter from "../FormFields/DropdownFilter.vue"
import LoadingIndicator from "../Global/LoadingIndicator.vue"
import ErrorIndicator from "../Global/ErrorIndicator.vue"

export default {
    components: {
        InsightsBlock,
        DropdownFilter,
        LoadingIndicator,
        ErrorIndicator
    },
    props: ["category", "title", "showRelatedContentFilters", "listViewContent"],
    data() {
        return {
            error: false,
            loading: true,
            skip: 0,
            take: 17,
            filters: ["", "", ""],
            services: [],
            content: [],
            featuredLeft: [],
            featuredRight: [],
            regular: [],
            loadMoreDisabled: false,
        }
    },
    mounted() {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('practice')) {
            this.filters[0] = searchParams.get('practice');
        }
        if (searchParams.has('industry')) {
            this.filters[1] = searchParams.get('industry');
        }
        if (searchParams.has('region')) {
            this.filters[2] = searchParams.get('region');
        }

        this.getServices();
        this.getContent();
    },
    methods: {
        loadMore: function () {
            this.skip += (this.take === 17 ? 17 : 12);
            this.take = 12;
            this.getContent();
        },
        filterContent: function () {
            this.skip = 0;
            this.take = 17;
            this.content = [];
            this.loadMoreDisabled = false;
            this.getContent();
        },
        sortContent: function () {
            this.featuredLeft = [];
            this.featuredRight = [];
            this.regular = [];
            this.content.forEach((insight, index) => {
                if (index < 2) {
                    this.featuredLeft.push(insight);
                }
                if (index > 1 && index < 5) {
                    this.featuredRight.push(insight);
                }
                if (index > 4) {
                    this.regular.push(insight);
                }
            });
        },
        getServices: function () {
            this.loading = true;
            axios.post("/api/services/filter-list?culture=en", {}, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then((response) => {
                    this.services = response.data.categories;
                })
                .catch((err) => {
                    this.error = true;
                });
        },
        getContent: function () {
            // this.loading = true;

            let filters = [];
            if (this.filters[0] != "") {
                filters.push("&practice=" + this.filters[0])
            }
            if (this.filters[1] != "") {
                filters.push("&industry=" + this.filters[1])
            }
            if (this.filters[2] != "") {
                filters.push("&region=" + this.filters[2])
            }

            let newUrl = `${window.location.origin}${window.location.pathname}?${filters.join("")}`;
            if (history.pushState) {
                history.pushState({}, "", newUrl);
            }

            axios.post("/api/insights/" + this.category + `?skip=${this.skip}&take=${this.take}${filters.join("")}`, {}, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then((response) => {
                    response.data.forEach((insight) => {
                        this.content.push(insight)
                    });
                    this.sortContent();
                    this.loading = false;
                    if (response.data.length === 0 || response.data.length < this.take) {
                        this.loadMoreDisabled = true;
                    }
                })
                .catch((err) => {
                    this.error = true;
                    this.loading = false;
                });
        }
    }
}
</script>

